<template>
  <div @load="loadImage">
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameTitle() }}
      </div>
    </div >
    <div class="gameplay_game_box_list gameplay_tap_box memory4">
      <div class="gameplay_tap_container pair">
        <div class="gameplay_tap_row" v-for="(row, rowIndex) in numOfRow" :key="row">
          <div class="card is-flipped" v-for="(answer, index) in numOfCols" :key="index"
               @click="sendAnswerUntilCompleted(twoDimensionalTable[rowIndex][index].brPosition1, twoDimensionalTable[rowIndex][index].brPosition2,twoDimensionalTable[rowIndex][index].brPosition3,twoDimensionalTable[rowIndex][index].brPosition4, rowIndex, index + 1)"
               :style="!buttonPushed ? 'cursor:pointer' : 'pointer-events:none'"
               :disabled="buttonPushed"
               :ref="index + 1">
            <div class="flip_face flip_face_front"></div>
            <div class="flip_face flip_face_back" >
              <img :src="twoDimensionalTable[rowIndex][index].card.url">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'MemoryFourOfAKind',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null,
      userHasAnsweredCorrect: false,
      data: 0,
      symbolInRow: 0,
      personalizedData: null,
      buttonPushed: true,
      brDisplayIndexXTable: [],
      brDisplayIndexYTable: [],
      mwDisplayIndexXTable: [],
      twoDimensionalTable: [],
      memoryTable: [],
      numOfRow: 0,
      numOfCols: 4,

    };
  },
  created() {
    console.log('in Game created hook');
    this.initGameData();
  },
  mounted() {
    this.viewTheCards();
    this.$nextTick(() => { this.loadImage(); });
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
  },
  methods: {
    ...mapMutations('game', [
      'resetGameState',
    ]),
    loadImage() {
      gameplayFooter();
    },
    initGameData() {
      this.symbolInRow = 0;
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      this.createMatrix();
    },
    createMatrix() {
      let index = 0;
      // this.gameInfo = this.gameCardDTOS.slice(0).sort((a, b) => a.mwDisplayIndex - b.mwDisplayIndex);
      this.numOfRow = this.gameInfo.gameCardDTOS.length === 16 ? 4 : 3;
      this.personalizedData = this.gameInfo.gameCardDTOS.slice(0).sort((a, b) => a.brPosition1 - b.brPosition1);
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.twoDimensionalTable[i][j] = this.personalizedData[index];
          index += 1;
        }
      }
    },
    viewTheCards() {
      let indexX = 1;
      let indexY = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.$refs[indexX][indexY].classList.add('is-flipped');
          indexX += 1;
        }
        indexX = 1;
        indexY += 1;
      }
      setTimeout(() => {
        this.timeToHideTheCards();
      }, this.gameInfo.hideCardsTimer);
    },
    timeToHideTheCards() {
      let indexX = 1;
      let indexY = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.$refs[indexX][indexY].classList.remove('is-flipped');
          indexX += 1;
        }
        indexX = 1;
        indexY += 1;
      }
      this.buttonPushed = false;
    },
    sendAnswerUntilCompleted(value, pair, pair1, pair2, rowIndex, colIndex) {
      this.$refs[colIndex][rowIndex].classList.add('is-flipped');
      this.brDisplayIndexXTable.push(colIndex);
      this.brDisplayIndexYTable.push(rowIndex);
      if (this.mwDisplayIndexXTable.length === 0 && this.symbolInRow === 0) {
        this.mwDisplayIndexXTable[0] = value;
        this.mwDisplayIndexXTable[1] = pair;
        this.mwDisplayIndexXTable[2] = pair1;
        this.mwDisplayIndexXTable[3] = pair2;
        this.buttonPushed = false;
        this.symbolInRow += 1;
      } else if (this.mwDisplayIndexXTable[0] === pair || this.mwDisplayIndexXTable[0] === pair1 || this.mwDisplayIndexXTable[0] === pair2) {
        if (!this.memoryTable.includes(value)) {
          this.memoryTable.push(value);
          this.symbolInRow += 1;
          if (this.symbolInRow === 4) {
            this.buttonPushed = true;
            this.sendAnswer(1);
          }
        }
      } else {
        this.symbolInRow = 0;
        this.buttonPushed = true;
        this.sendAnswer(0);
      }
    },
    sendAnswer(value) {
      let isCorrectAnswer = false;
      this.$axios({
        url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${value}`,
        method: 'GET',
        headers: {
          Authorization: this.jwtInVuex,
        },
      }).then((response) => {
        const responseData = response.data.data;
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          if (responseData.status === 'WRONG_ANSWER') {
            for (let i = 0; i < this.brDisplayIndexXTable.length; i += 1) {
              this.$refs[this.brDisplayIndexXTable[i]][this.brDisplayIndexYTable[i]].classList.add('notmatch');
            }
            isCorrectAnswer = false;
          } else if (responseData.status === 'CORRECT_ANSWER') {
            this.userHasAnsweredCorrect = true;
            for (let i = 0; i < this.brDisplayIndexXTable.length; i += 1) {
              this.$refs[this.brDisplayIndexXTable[i]][this.brDisplayIndexYTable[i]].classList.add('match');
            }
            isCorrectAnswer = true;
          }
        }
        console.log('wait 1,5 secs for response and go to next game');
        setTimeout(() => {
          console.log('Go to next game');
          this.normalTransition = true;
          this.storeBrainiacGameData(isCorrectAnswer);
        }, 1500);
      }).catch((error) => {
        console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
      });
    },
    gameTitle() {
      if (this.userHasAnsweredCorrect) {
        return this.getTranslations.home_game_memory_four_of_a_kind_perfect;
      }
      return this.getTranslations.home_game_memory_four_of_a_kind_question;
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/memory/MemoryFourOfAKind.vue